<div class="form-group mb-0 d-flex">
  <button class="btn btn-rbv mr-2" (click)="redirectToMap()">
    Go
  </button>
  <input type="text" class="form-control" placeholder="search"
    [(ngModel)]="searchValue" id="google_search_{{index}}"/>
</div>

<div class="mt-3" *ngIf="placesList.length > 0">
  <div *ngFor="let place of placesList; let i=index;" class="placeList">
    <!-- Other Details -->
    <div class="w-100">
      <div class="placeName">
        {{place.PLACE.name}}
        <span class="floatRight" *ngIf="place.RATING >= 0">
          {{place.RATING}}
          <i class="fa {{place.RATING >= 1 || place.RATING === 0.8 || place.RATING === 0.9 ? 'fa-star' : place.RATING === 0 ? 'fa-star-o' : 'fa-star-half-o'}}"></i>
          <i class="fa {{place.RATING >= 2 || place.RATING === 1.8 || place.RATING === 1.9 ? 'fa-star' : place.RATING <= 1 ? 'fa-star-o' : 'fa-star-half-o'}}"></i>
          <i class="fa {{place.RATING >= 3 || place.RATING === 2.8 || place.RATING === 2.9 ? 'fa-star' : place.RATING <= 2 ? 'fa-star-o' : 'fa-star-half-o'}}"></i>
          <i class="fa {{place.RATING >= 4 || place.RATING === 3.8 || place.RATING === 3.9 ? 'fa-star' : place.RATING <= 3 ? 'fa-star-o' : 'fa-star-half-o'}}"></i>
          <i class="fa {{place.RATING === 5 || place.RATING === 4.8 || place.RATING === 4.9 ? 'fa-star' : place.RATING <= 4 ? 'fa-star-o' : 'fa-star-half-o'}}"></i>
        </span>

        <div @fadeOut class="copied" *ngIf="place.COPIED">Text Copied!</div>
        <i class="fa fa-clone copy" (click)="copyText(place, 1)"></i>
      </div>

      <!-- Address -->
      <div class="placeAddress">
        {{place.PLACE.formatted_address}}
        <i class="fa fa-clone copy" (click)="copyText(place, 2)"></i>
      </div>

      <div class="placeAddress" *ngIf="place.NUMBER || place.WEBSITE">
        <!-- Number -->
        <div *ngIf="place.NUMBER">
          Number : {{place.NUMBER}}
          <i class="fa fa-clone copy" (click)="copyText(place, 3)"></i>
        </div>

        <!-- Website -->
        <div *ngIf="place.WEBSITE">
          Website : {{place.WEBSITE}}
          <i class="fa fa-clone copy" (click)="copyText(place, 4)"></i>
        </div>
      </div>

      <!-- Loading imdicator -->
      <div *ngIf="place.SHOW_DETAIL_LOADING" class="textCenter">
        <span class="loading-icon-small"></span>
      </div>
    </div>
  </div>
</div>

<div class="map-view marginBottom15" id="google_search_view{{index}}" [hidden]="true"></div>
